__turbopack_context__.v({
  "columns": "CtaList-module-scss-module__yvPgdq__columns",
  "ctaGroup": "CtaList-module-scss-module__yvPgdq__ctaGroup",
  "ctaList": "CtaList-module-scss-module__yvPgdq__ctaList",
  "link": "CtaList-module-scss-module__yvPgdq__link",
  "linkItem": "CtaList-module-scss-module__yvPgdq__linkItem",
  "links": "CtaList-module-scss-module__yvPgdq__links",
  "oneColumn": "CtaList-module-scss-module__yvPgdq__oneColumn",
  "pill": "CtaList-module-scss-module__yvPgdq__pill",
  "text": "CtaList-module-scss-module__yvPgdq__text",
  "twoColumns": "CtaList-module-scss-module__yvPgdq__twoColumns",
});
